export default __webpack_public_path__ + "static/media/carta6.271c8e7c.png";